// @flow

import OrderDetailView from "apps/orders/OrderDetailView"
import React from "react"
import { Route, Switch } from "react-router-dom"
import { hotWrapper } from "shared/utils/hotWrapper"

import OrderSearchView from "./OrderSearchView"

const OrderSearchEntry = () => {
  return (
    <Switch>
      <Route exact path="/iframe/order-search/" component={OrderSearchView} />
      <Route
        exact
        path="/iframe/order-search/orders/detail/:id"
        render={({ match }) => <OrderDetailView orderId={match.params.id} />}
      />
    </Switch>
  )
}

export default (hotWrapper(OrderSearchEntry): any)
